import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDateTimePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "moment/locale/es";

var SMDatePicker = function SMDatePicker(_ref) {
  var format = _ref.format,
      label = _ref.label,
      id = _ref.id,
      margin = _ref.margin,
      variant = _ref.variant,
      field = _ref.field,
      disableToolbar = _ref.disableToolbar,
      form = _ref.form,
      disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      time = _ref.time,
      other = _objectWithoutProperties(_ref, ["format", "label", "id", "margin", "variant", "field", "disableToolbar", "form", "disablePast", "disableFuture", "time"]);

  // const [ selectedDate, setDate ] = useState(new Date());
  // const handleChange = (date) => {
  // 	console.log(date);
  // 	setDate(date);
  // };
  return /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils,
    locale: "en"
  }, time ? /*#__PURE__*/React.createElement(KeyboardDateTimePicker, Object.assign({
    onError: console.log,
    ampm: false,
    name: field.name,
    disableToolbar: disableToolbar,
    inputVariant: variant,
    format: format,
    margin: margin,
    id: id,
    label: label,
    value: field.value,
    autoOk: true,
    disablePast: disablePast,
    disableFuture: disableFuture,
    invalidDateMessage: "fecha incorrecta",
    onChange: function onChange(date) {
      return date && form.setFieldValue(field.name, date, true);
    }
  }, other)) : /*#__PURE__*/React.createElement(KeyboardDatePicker, Object.assign({
    ampm: false,
    name: field.name,
    disableToolbar: disableToolbar,
    inputVariant: variant,
    format: format,
    margin: margin,
    id: id,
    label: label,
    value: field.value,
    autoOk: true,
    disablePast: disablePast,
    disableFuture: disableFuture,
    invalidDateMessage: "fecha incorrecta",
    onChange: function onChange(date) {
      return date && form.setFieldValue(field.name, date, true);
    }
  }, other)));
};

SMDatePicker.defaultProps = {
  format: "DD/MM/YYYY",
  disabledToolbar: false,
  variant: "outlined",
  margin: "normal"
};
export { SMDatePicker }; // display: (filterList, onChange, index, column) => {
// 	console.log('------display-------')
// 	console.log('filterList', filterList)
// 	return [
// 		<MuiPickersUtilsProvider utils={MomentUtils} locale="es">
// 			<DateTimePicker
// 				label="min"
// 				value={filterList[index][0] || ''}
// 				onChange={event => {
// 					console.log('event min', event)
// 					filterList[index][0] = event;
// 					onChange(filterList[index], index, column);
// 				}}
// 				style={{ width: '45%', marginRight: '5%' }}
// 			/>
// 			<DateTimePicker
// 				label="max"
// 				value={filterList[index][1] || ''}
// 				onChange={event => {
// 					console.log('event max', event)
// 					filterList[index][1] = event;
// 					onChange(filterList[index], index, column);
// 				}}
// 				style={{ width: '45%' }}
// 			/>
// 		</MuiPickersUtilsProvider>]